import ValueNode from './ValueNode';
import TextType from './TextType';

export default class TextNode extends ValueNode<string> {

	public toText (textType = TextType.PLAIN) {
		return textType === TextType.LATEX ? '\\text{' + this.getValue() + '}' : this.getValue();
	}

	public normalized () {
		return new TextNode(this.getValue().toLocaleLowerCase());
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/TextNode.ts